<template>
  <div :id="getId" class="address-lookup">
    <h4>
      {{ this.title }}
    </h4>
    <div class="form-group">
      <label for="party-name" class="form-label">Name</label>
      <input class="form-control" v-model="party.name" id="party-name"/>
    </div>
    <div class="form-group">
      <label for="party-code" class="form-label">Code</label>
      <input class="form-control" v-model="party.code" id="party-code"/>
    </div>
    <!--
    <div class="form-group">
      <label for="party-country" class="form-label">Country</label>
      <select class="form-control" v-model="party.country" id="party-country">
        <option v-for="(c, i) in countries" :value="c.id">{{ c.name }}</option>
      </select>
    </div>
    -->
    <div class="form-group">
      <label for="parties" class="form-label">Parties <small>({{ parties.length }} results)</small></label>
      <p v-show="!parties.length">Options will appear here</p>
      <select v-show="parties.length" class="form-control party-white-bg" v-model="party.choice" id="parties" style="color:#000;">
        <option style="background:#fff !important;" v-for="(p, i) in parties" :value="p">{{ p.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div  class="btn btn-default sq" @click="search">
        Search <pulse-loader v-show="loading" :size="'3px'" :style="{ display: 'inline' }"></pulse-loader>
      </div>
      <div  class="btn btn-primary sq" @click="save">
        Select
      </div>
      <div  class="btn btn-danger sq" @click="cancel">
        Cancel
      </div>
    </div>
  </div>
</template>
<script>
  import event from '../event'
  import API from '../api/endpoints'
  import PulseLoader from '../modules/helpers/PulseLoader.vue'
  import IEHackMixin from '../modules/helpers/IEHackMixin'
  export default {
    name: 'PartyLookup',
    props: ['title', 'initData', 'event', 'callerId', 'isOpen'],
    mixins: [IEHackMixin],
    components: {
      PulseLoader
    },
    data () {
      return {
        type: '',
        party: {
          name: '',
          code: '',
          country: '',
          choice: null
        },
        loading: false,
        parties: []
      }
    },
    watch: {
    },
    computed: {
      getId () {
        return 'party-lookup-' + this._uid
      },
      countries () {
        return this.$store.getters['systemOption/countries']
      },
      partyGroups () {
        return this.$store.getters['authentication/userPartyGroups'].map(({id}) => id)
      },
      user () {
        return this.$store.getters['authentication/user']
      }
    },
    methods: {
      save () {
        event.$emit(this.event, {
          callerId: this.callerId,
          data: this.party
        })
        event.$emit('right-close-and-destroy')
        this.$destroy()
      },
      cancel () {
        event.$emit('right-close-and-destroy')
        this.$destroy()
      },
      search () {
        this.loading = true
        let params = {
          code: this.party.code,
          name: this.party.name,
          category: this.type === 'Account' ? 'CORP' : 'SP',
          partyGroups: JSON.stringify(this.partyGroups)
        }
        if (this.user.brand) {
          params.brand = this.user.brand
        }
        this.$http.get(API.GET_PARTIES, { params })
        .then(({data}) => {
          if (data) {
            this.parties = data
          }
        }).catch((err) => {
          console.log(err)
        }).then(() => {
          this.loading = false
        })
      }
    },
    mounted () {
      if (this.initData.type) { this.type = this.initData.type }
    }
  }
</script>

<style>
  .party-white-bg {
    background: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartyLookup.vue